module.exports = __webpack_public_path__ + "media/images/kitchen@2x-1375b564e98d24a97a1364a03be8eaef.jpg";